export const VARIANTS = ['solid', 'outline'];
export const COLOR_SCHEMES = ['primary', 'brand', 'success', 'warning', 'danger'];
export const DEFAULT_PROPS = {
    variant: 'solid',
    colorScheme: 'primary',
};
